import { Box, Container, Flex, Input, Link, Text } from "@chakra-ui/react";
import { Modal } from "components";
import { useState } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { MdCreditCard } from "react-icons/md";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { SiMastercard, SiVisa } from "react-icons/si";

const BillingMethod = () => {
  const [editBillingInfo, setEditBillingInfo] = useState(false);
  const getColor = () => editBillingInfo && '#A3A3A3';

    return (
      <Container >
        <Flex justifyContent='space-between' marginTop={10} marginBottom={5} align='center'>
              <Text fontWeight={700} color={!editBillingInfo ? getColor() || '' : ''} fontSize='26px'>Registered Cards</Text>
              <Link fontWeight={600} color={!editBillingInfo ? getColor() || '' : ''} fontSize='16px' onClick={() => setEditBillingInfo(!editBillingInfo)}>{editBillingInfo ? 'Save':'Edit'}</Link>
        </Flex>
        <Box  border="1px solid #E9EEF1" borderRadius="50px"  padding={10} marginBottom={10}>
          <Flex justifyContent="space-between" align="center">
            <Flex align="center">
              <MdCreditCard size="40px" />
              <Text fontWeight={600} fontSize="20px" marginLeft={3}>Registered cards</Text>
            </Flex>
            <SiVisa size="40px"  />
          </Flex>
          <Flex marginBottom={5} marginTop={3}>
              <Input padding={8} variant='filled' placeholder='Card number'/>
          </Flex>
          <Flex marginBottom={5}>
              <Input padding={8} variant='filled' placeholder='Card owner'/>
          </Flex>
          <Flex marginBottom={5} justifyContent='space-between'>
              <Input padding={8} variant='filled' marginRight={5} placeholder='Expiry date'/>
              <Input padding={8} variant='filled' placeholder='CVC'/>
          </Flex>
          <Flex justifyContent="flex-end" align="center">
            <RiDeleteBin5Fill />
            <Text marginLeft={3} fontWeight={400} fontSize="17px">Delete registered card</Text>
          </Flex>
        </Box>
        <Modal iconButton={<AiOutlinePlusCircle />} title={""} buttonLabel="Add Card" buttonIcon={<AiOutlinePlusCircle />} label="Add New Card" >
          <Flex justifyContent="space-between" align="center" marginTop={5}>
            <Flex align="center">
              <MdCreditCard size="40px" />
              <Text fontWeight={600} fontSize="20px" marginLeft={3}>New Card</Text>
            </Flex>
            <Flex align="center">
              <SiMastercard />
              <SiVisa size="40px" />
            </Flex>
          </Flex>
          <Flex marginBottom={5} marginTop={3}>
              <Input padding={8} variant='filled' placeholder='Card number'/>
          </Flex>
          <Flex marginBottom={5}>
              <Input padding={8} variant='filled' placeholder='Card owner'/>
          </Flex>
          <Flex marginBottom={5} justifyContent='space-between'>
              <Input padding={8} variant='filled' marginRight={5} placeholder='Expiry date'/>
              <Input padding={8} variant='filled' placeholder='CVC'/>
          </Flex>
        </Modal>
      </Container>
    );
  };
  
  export { BillingMethod };
  